import React from "react";
import styled, { createGlobalStyle } from "styled-components";
import { color, font } from "./tokens";
import LenisProvider from "./LenisProvider";
import { Section } from "./primitives";
import TimelineRail from "./TimelineRail";
import BootStrip from "./sections/BootStrip";
import Nav from "./sections/Nav";
import Hero from "./sections/Hero";
import StatsSection from "./sections/StatsSection";
import ZipSection from "./sections/ZipSection";
import PaloFanSection from "./sections/PaloFanSection";
import ZipReturnSection from "./sections/ZipReturnSection";
import FourMationSection from "./sections/FourMationSection";
import SeniorSection from "./sections/SeniorSection";
import RnDSection from "./sections/RnDSection";
import StackSection from "./sections/StackSection";
import FooterSection from "./sections/FooterSection";

const EditorialGlobal = createGlobalStyle`
  *, *::before, *::after {
    box-sizing: border-box;
  }
  html {
    scroll-behavior: auto;
  }
  body {
    background: ${color.paper};
    color: ${color.ink};
    font-family: ${font.body};
  }
  ::selection {
    background: ${color.accent};
    color: ${color.ink};
  }
`;

const Page = styled.main`
  background: ${color.paper};
  color: ${color.ink};
  text-align: left;
  overflow-x: clip;
`;

/**
 * The single scrolling editorial document. Career eras run 01–05
 * (Zip → Palo IT → Zip return → 4Mation → Palo IT senior), mirrored by
 * the fixed timeline rail on the left.
 */
const EditorialPage: React.FC = () => {
  return (
    <LenisProvider>
      <EditorialGlobal />
      <Page>
        <Nav />
        <TimelineRail />
        <BootStrip />
        <Section>
          <Hero />
          <StatsSection />
          <ZipSection />
          <PaloFanSection />
          <ZipReturnSection />
          <FourMationSection />
          <SeniorSection />
          <RnDSection />
          <StackSection />
        </Section>
        <FooterSection />
      </Page>
    </LenisProvider>
  );
};

export default EditorialPage;
